import React from "react";
import { IPolicy } from "../../generated/models/policy";

export const AiiaPolicy = (props: IPolicy) => (
  <div className="mt-3 mb-3">
    By clicking the button {props.buttonPosition}, You consent to the processing
    of your financial data, for the purpose of quality control the connection to{" "}
    {props.providerId}. We will create a payment on your behalf, and for that
    purpose we might process the list of accounts you have access to. For more
    information about the processing of your data, including information on how
    to revoke your consent, please see the{" "}
    <a href="/privacy-policy">privacy policy</a>.
  </div>
);
